import React from "react";
import { Navigate, useRoutes } from "react-router-dom";

import AdminPanelLayout from "../components/admin-panel/admin-panel-layout";
import Login from "../pages/authentication/Login";
import Dashboard from "../pages/admin/Dashboard";
import Users from "../pages/admin/Users";
import Reports from "../pages/admin/Reports";
import Analytics from "../pages/admin/Analytics";
import Verification from "../pages/admin/Verification";
import ActivityLog from "../pages/admin/ActivityLog";

export const PrivateRoute = ({ children }) => {
  const user = localStorage.getItem("signova-admin");
  return user ? children : <Navigate to="/login" />;
};

export const PublicRoute = ({ children }) => {
  const user = localStorage.getItem("signova-admin");
  return user ? <Navigate to="/dashboard" /> : children;
};

const Routes = () => {
  return useRoutes([
    {
      path: "/",
      element: (
        <PrivateRoute>
          <AdminPanelLayout />
        </PrivateRoute>
      ),
      children: [
        { path: "/", element: <Navigate to="/dashboard" /> },
        { path: "/dashboard", element: <Dashboard /> },
        { path: "/users", element: <Users /> },
        { path: "/users/:userId", element: <Users /> },
        { path: "/reports", element: <Reports /> },
        { path: "/analytics", element: <Analytics /> },
        { path: "/verification", element: <Verification /> },
        { path: "/activity-log", element: <ActivityLog /> },
      ],
    },
    {
      path: "/login",
      element: (
        <PublicRoute>
          <Login />
        </PublicRoute>
      ),
    },
  ]);
};

export default Routes;
